export default __webpack_public_path__ + "static/media/no-custom.d881d1f2.svg";